import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { defaultExpense } from 'shared/constants';
import { useQuoteState } from 'shared/contexts';
import { ExpenseForm } from 'shared/types';
import { buildQuoteExpense } from 'shared/utility';
import { NewExpenseFields } from './new-expense-fields';

export function NewExpense() {
  const { newExpenseDialogOpen, toggleNewExpenseDialog, setTempExpense } = useQuoteState();

  const methods = useForm<ExpenseForm>({
    defaultValues: defaultExpense,
  });
  const { handleSubmit, reset } = methods;

  useEffect(() => {
    reset(defaultExpense);
  }, [newExpenseDialogOpen, reset]);
  const onClose = useCallback(() => {
    toggleNewExpenseDialog();
  }, [toggleNewExpenseDialog]);

  const onSubmit = useCallback(
    (data: ExpenseForm) => {
      const newExpense = buildQuoteExpense(data);
      setTempExpense(newExpense);
      onClose();
    },
    [setTempExpense, onClose]
  );

  return (
    <Dialog open={newExpenseDialogOpen} onClose={onClose}>
      <DialogTitle>Add Expense</DialogTitle>
      <DialogContent>
        <FormProvider {...methods}>
          <form aria-label='form' id='new-expense-form' onSubmit={handleSubmit(onSubmit)}>
            <NewExpenseFields />
          </form>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type='submit' form='new-expense-form' color='secondary' variant='contained'>
          Add Expense
        </Button>
      </DialogActions>
    </Dialog>
  );
}
